import React from "react";
import { useTranslation } from "react-i18next";

function ContactSection() {
  const { t } = useTranslation();

  return (
    <section className="nw-section" id="contact">
      <div className="nw-section-head">
        <h2>{t("contact.title")}</h2>
      </div>
      <div className="nw-contact-grid">
        <form
          className="nw-form"
          action="mailto:contact@northwindaudio.com"
          method="post"
          encType="text/plain"
        >
          <label>
            {t("contact.nameLabel")}
            <input
              type="text"
              name="name"
              placeholder={t("contact.namePlaceholder")}
              required
            />
          </label>
          <label>
            {t("contact.emailLabel")}
            <input
              type="email"
              name="email"
              placeholder={t("contact.emailPlaceholder")}
              required
            />
          </label>
          <label>
            {t("contact.messageLabel")}
            <textarea
              name="message"
              rows="5"
              placeholder={t("contact.messagePlaceholder")}
              required
            />
          </label>
          <button className="btn primary" type="submit">
            {t("contact.submit")}
          </button>
        </form>

        <div className="nw-contact-card">
          <h3>{t("contact.socialTitle")}</h3>
          <div className="nw-social-cards">
            <a
              className="nw-social-card"
              href="https://www.youtube.com/@kalendaproject"
              target="_blank"
              rel="noreferrer"
              aria-label="YouTube"
            >
              <span className="nw-social-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" role="presentation" focusable="false">
                  <path
                    d="M10 8l6 4-6 4V8zm11-1.5c-.3-1.2-1.2-2.1-2.4-2.4C16.7 3.6 12 3.6 12 3.6s-4.7 0-6.6.5C4.2 4.4 3.3 5.3 3 6.5 2.5 8.4 2.5 12 2.5 12s0 3.6.5 5.5c.3 1.2 1.2 2.1 2.4 2.4 1.9.5 6.6.5 6.6.5s4.7 0 6.6-.5c1.2-.3 2.1-1.2 2.4-2.4.5-1.9.5-5.5.5-5.5s0-3.6-.5-5.5z"
                    fill="currentColor"
                  />
                </svg>
              </span>
              <span className="nw-social-name">YouTube</span>
            </a>
            <a
              className="nw-social-card"
              href="https://www.instagram.com/kalendaproject"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
            >
              <span className="nw-social-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" role="presentation" focusable="false">
                  <path
                    d="M7 3h10a4 4 0 014 4v10a4 4 0 01-4 4H7a4 4 0 01-4-4V7a4 4 0 014-4zm10 2H7a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2zm-5 3.5a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm0 2a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm4.5-.9a.9.9 0 11.001 1.801A.9.9 0 0116.5 9.6z"
                    fill="currentColor"
                  />
                </svg>
              </span>
              <span className="nw-social-name">Instagram</span>
            </a>
            {/* <a
              className="nw-social-card is-spotify"
              href="https://www.spotify.com"
              target="_blank"
              rel="noreferrer"
              aria-label="Spotify"
            >
              <span className="nw-social-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" role="presentation" focusable="false">
                  <path
                    d="M12 0.8C5.9 0.8 0.8 5.9 0.8 12S5.9 23.2 12 23.2 23.2 18.1 23.2 12 18.1 0.8 12 0.8zm5.3 16.2c-.2.3-.6.4-.9.2-2.5-1.5-5.7-1.9-9.4-1.1-.4.1-.7-.2-.8-.5-.1-.4.2-.7.5-.8 4-.9 7.5-.5 10.3 1.3.4.2.4.6.3.9zm1.3-2.8c-.3.4-.8.5-1.2.2-2.9-1.8-7.3-2.3-10.6-1.3-.5.1-1-.1-1.1-.6-.1-.5.1-1 .6-1.1 3.9-1.2 8.7-.6 12.1 1.5.4.3.5.8.2 1.3zm.1-3c-3.4-2-9-2.2-12.3-1.2-.6.2-1.2-.1-1.4-.7-.2-.6.1-1.2.7-1.4 3.8-1.2 10.1-1 14 1.4.5.3.7 1 .4 1.5-.3.5-1 .7-1.5.4z"
                    fill="currentColor"
                  />
                </svg>
              </span>
              <span className="nw-social-name">Spotify</span>
            </a> */}
            {/* <a
              className="nw-social-card"
              href="https://soundcloud.com"
              target="_blank"
              rel="noreferrer"
              aria-label="SoundCloud"
            >
              <span className="nw-social-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" role="presentation" focusable="false">
                  <path
                    d="M19.2 10.3a3.8 3.8 0 00-3.4 2h-.7V8.5a5.6 5.6 0 00-2.4-.6 5.3 5.3 0 00-2.1.4v4h-.6v-2.7a5.2 5.2 0 00-1.6 1v1.7h-.7V9.9a4.6 4.6 0 00-1.3 2.7h-.7v-1.5a4 4 0 00-.9 2.4v1.6h-.7v-1.2a3.6 3.6 0 00-.5 1.8v1.1h14.8a3.1 3.1 0 00.8-6.5z"
                    fill="currentColor"
                  />
                </svg>
              </span>
              <span className="nw-social-name">SoundCloud</span>
            </a> */}
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
